<template>
  <div class="page-container">
    <div>
      <el-button type="primary" @click="addOrUpdateHandle()" class="mb16" v-if="isAuth('engagement:save')">Add Client</el-button>
    </div>
    <div id="searchArea">
      <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList(1)">
        <el-form-item>
          <el-input
            v-model="dataForm.keyword"
            :placeholder="kwPlaceHolder"
            class="wd416 input-with-select-lg"
            v-regexFilter="dataForm.kwType === 'id' ? numberRegex : halfWidthRegex"
            clearable
          >
            <el-select
              v-model="dataForm.kwType"
              slot="prepend"
              placeholder="please select"
              @change="
                () => {
                  dataForm.keyword = '';
                }
              "
            >
              <el-option v-for="item in kwTypes" :key="item.value" :label="item.title" :value="item.value"></el-option>
            </el-select>
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-select v-model="dataForm.inChargeUserName" placeholder="In-charge" clearable filterable>
            <el-option
              v-for="item in inChargeList"
              :key="`inCharge-${item.id}`"
              :label="`${item.nickname}-${item.staffNo}-${item.position}`"
              :value="item.username"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="dataForm.status" multiple clearable placeholder="Status">
            <el-option v-for="item in engagementStatusList" :key="item.value" :label="item.title" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-date-picker-range
            :startDate="dataForm.coveredPeriodStart"
            :endDate="dataForm.coveredPeriodEnd"
            startPlaceholder="Covered (Start Date)"
            endPlaceholder="Covered (End Date)"
            @startSelectChange="
              val => {
                dataForm.coveredPeriodStart = val;
              }
            "
            @endSelectChange="
              val => {
                dataForm.coveredPeriodEnd = val;
              }
            "
          ></el-date-picker-range>
        </el-form-item>
        <el-form-item>
          <el-select-all
            :width="200"
            :optionList="monthOptions"
            placeholder="FY end"
            @elSelectAllChange="
              list => {
                dataForm.fyEndMonth = list;
              }
            "
          ></el-select-all>
        </el-form-item>
        <el-form-item>
          <el-select v-model="dataForm.companyType" placeholder="Entity Type" filterable clearable>
            <el-option v-for="item in engagementCompanyTypeList" :key="item.title" :label="item.title" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="dataForm.companyCountry" placeholder="Entity Country" filterable clearable>
            <el-option v-for="item in countryList" :key="item.value" :label="item.title" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <uen-select-remote-search v-model="dataForm.uen" placeholder="UEN"></uen-select-remote-search>
        </el-form-item>
        <el-form-item class="pt1">
          <el-select-all
            class="controlLeft"
            :width="202"
            :optionList="controlTypeObjList"
            placeholder="Service Type"
            @elSelectAllChange="
              list => {
                dataForm.controlType = list;
              }
            "
          ></el-select-all>
          <el-select v-model="dataForm.isBlank" placeholder="Select Status Or Blank" class="wd180 controlCentre" @change="isBlankChange">
            <el-option label="Select Status" :value="0"></el-option>
            <el-option label="Select Blank" :value="1"></el-option>
          </el-select>
          <template v-if="dataForm.isBlank == 0">
            <el-select-all
              class="controlCentre"
              :width="200"
              :optionList="engagementControlStatusList"
              placeholder="Detailed Status"
              @elSelectAllChange="
                list => {
                  dataForm.controlStatus = list;
                }
              "
            ></el-select-all>
            <el-date-picker-range
              :startDate="dataForm.controlDeadlineStart"
              :endDate="dataForm.controlDeadlineEnd"
              :width="150"
              @startSelectChange="
                val => {
                  dataForm.controlDeadlineStart = val;
                }
              "
              @endSelectChange="
                val => {
                  dataForm.controlDeadlineEnd = val;
                }
              "
              class="controlRight"
            ></el-date-picker-range>
          </template>
        </el-form-item>
        <el-form-item>
          <el-date-picker-range
            :startDate="dataForm.incorpDateStart"
            :endDate="dataForm.incorpDateEnd"
            startPlaceholder="Incorp. (Start Date)"
            endPlaceholder="Incorp. (End Date)"
            @startSelectChange="
              val => {
                dataForm.incorpDateStart = val;
              }
            "
            @endSelectChange="
              val => {
                dataForm.incorpDateEnd = val;
              }
            "
          ></el-date-picker-range>
        </el-form-item>
        <el-form-item>
          <el-select v-model="dataForm.supplierId" filterable clearable placeholder="Supplier">
            <el-option v-for="item in supplierList" :key="item.id" :label="item.companyName" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button icon="el-icon-search" type="primary" plain v-debounce @click="getDataList(1)">Search</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div id="operationArea">
      <!-- 导出 excel -->
      <el-button
        v-if="isAuth('engagement:export')"
        type="primary"
        plain
        size="small"
        icon="el-icon-download"
        :disabled="totalCount == 0"
        :loading="batchDownBtnLoading"
        @click="handleExportExcel"
        class="mb16"
      >
        Export Excel
      </el-button>
    </div>
    <div>
      <el-table
        max-height="600"
        :data="dataList"
        v-loading="dataListLoading"
        @sort-change="customTableSortChange"
        :default-sort="{ prop: 'clientCode', order: 'descending' }"
        style="width: 100%"
      >
        <el-table-column prop="id" align="center" label="ID" fixed="left" width="80" sortable="custom"></el-table-column>
        <el-table-column align="center" label="Supplier" width="160" fixed="left">
          <template slot-scope="scope">
            <p v-if="scope.row.relatedUserTransactions?.length > 0">
              {{ supplierAbbrDeduplicateFormat(scope.row.relatedUserTransactions.map(item => item.supplier)) }}
            </p>
          </template>
        </el-table-column>
        <el-table-column prop="clientCode" align="center" label="Client Code" fixed="left" width="126" sortable="custom"></el-table-column>
        <el-table-column prop="type" align="center" label="Type" fixed="left" width="100"></el-table-column>
        <el-table-column align="center" label="Trans. No." fixed="left" width="100">
          <template slot-scope="scope">
            <span v-if="scope.row.relatedUserTransactions?.length > 0">
              {{ scope.row.relatedUserTransactions.map(item => item.transactionNo).join(", ") }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="uen" align="center" label="UEN" fixed="left" width="100"></el-table-column>
        <el-table-column prop="companyName" align="center" label="Entity Name" fixed="left" width="150"></el-table-column>
        <el-table-column prop="coveredPeriodStart" align="center" label="Covered Period" fixed="left" width="154" sortable="custom">
          <template slot-scope="scope">
            <p v-if="scope.row.coveredPeriodStart">{{ scope.row.coveredPeriodStart }}</p>
            <p v-if="scope.row.coveredPeriodEnd">{{ scope.row.coveredPeriodEnd }}</p>
          </template>
        </el-table-column>
        <el-table-column align="center" label="Status" fixed="left" width="100">
          <template slot-scope="scope">
            <p>{{ engagementStatusFormat(scope.row.status) }}</p>
          </template>
        </el-table-column>
        <el-table-column align="center" label="In-charge" width="200">
          <template slot-scope="scope">
            <span v-if="scope.row.relatedUserTransactions">
              {{ inChargeDeduplicateFormat(scope.row.relatedUserTransactions) }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="previousCompanyName" align="center" label="Previous Entity Name" width="250"></el-table-column>
        <el-table-column prop="incorpDate" align="center" label="Incorp. date" width="150" sortable="custom">
          <template slot-scope="scope">
            <el-date-picker
              v-model="scope.row.incorpDate"
              type="date"
              :format="`dd [${monthList[parseInt(scope.row.incorpDate.split('-')[1]) - 1]}] yyyy`"
              value-format="yyyy-MM-dd"
              v-if="scope.row.incorpDate"
              :clearable="false"
              :readonly="true"
              disabled
              class="fluid-width datePicker"
            ></el-date-picker>
          </template>
        </el-table-column>
        <el-table-column prop="fyPeriod" align="center" label="FY Period" width="150"></el-table-column>
        <el-table-column prop="fyEnd" align="center" label="FY End" width="150">
          <template slot-scope="scope">
            <el-date-picker
              v-model="scope.row.fyEnd"
              type="date"
              :format="`dd [${monthList[parseInt(scope.row.fyEnd.split('-')[0]) - 1]}]`"
              value-format="MM-dd"
              v-if="scope.row.fyEnd"
              :clearable="false"
              :readonly="true"
              disabled
              class="fluid-width datePicker"
            ></el-date-picker>
          </template>
        </el-table-column>
        <el-table-column prop="companyCountry" align="center" label="Entity Country" width="150"></el-table-column>
        <el-table-column align="center" label="Entity Type" width="150">
          <template slot-scope="scope">
            <p>{{ engagementCompanyTypeFormat(scope.row.companyType) }}</p>
          </template>
        </el-table-column>
        <el-table-column prop="controlDataList" align="center" label="Service Type" :formatter="serviceTypeFormat" min-width="150"></el-table-column>
        <el-table-column v-for="label in engagementControlTypeList" :key="`ctrl-col-${label}`" align="center" :label="label" width="210">
          <template slot-scope="scope">
            <div v-for="dead in scope.row.controlDataList" :key="`dead${scope.row.id}${dead.id}`">
              <p v-if="dead.controlType && dead.controlType === label">
                <span>{{ dead.deadline }}</span>
                <span :class="statusDeadColor(dead.status)">, {{ engagementControlStatusFormat(dead.status) }}</span>
              </p>
            </div>
          </template>
        </el-table-column>
        <el-table-column fixed="right" align="center" width="100" label="Action">
          <template slot-scope="scope">
            <el-button v-if="isAuth('engagement:update')" type="text" class="fwb ml0" @click="addOrUpdateHandle(scope.row)">Edit</el-button>
            <el-button v-if="isAuth('engagement:delete')" type="text" class="fwb ml0" @click="deleteHandle(scope.row)">Delete</el-button>
            <el-button v-if="isAuth('engagement:charge') || isAuth('engagement:linked')" type="text" class="fwb ml0" @click="detailHandler(scope.row.id)">
              Detail
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <pagination
      :current="current"
      :pageSize="pageSize"
      :totalCount="totalCount"
      @size-change="sizeChangeHandle"
      @current-change="currentChangeHandle"
    ></pagination>

    <!-- 弹窗, 新增 / 修改 -->
    <add-or-update ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
  </div>
</template>

<script>
import AddOrUpdate from "./modal/AddOrUpdate";
import { downloadFile } from "@/utils";
import ElSelectAll from "@/components/ElSelectAll";
import ElDatePickerRange from "@/components/ElDatePickerRange";
import UenSelectRemoteSearch from "@/components/SelectRemoteSearch/uen";
import searchMixin from "@/mixins/searchMixin";
import tableMixin from "@/mixins/tableMixin";
import Pagination from "@/components/Pagination";
import paginationMixin from "@/mixins/paginationMixin";
import formatterMixin from "@/mixins/formatterMixin";
import { mapState } from "vuex";
export default {
  mixins: [searchMixin, tableMixin, paginationMixin, formatterMixin],
  components: {
    AddOrUpdate,
    ElSelectAll,
    ElDatePickerRange,
    UenSelectRemoteSearch,
    Pagination,
  },
  data() {
    return {
      monthList: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
      kwTypes: [
        {
          title: "Client Code",
          value: "clientCode",
          placeholder: "Client Code",
        },
        {
          title: "Entity Name",
          value: "companyName",
          placeholder: "Entity Name",
        },
        {
          title: "Transaction No.",
          value: "transactionNo",
          placeholder: "Transaction No.",
        },
        {
          title: "Type",
          value: "type",
          placeholder: "Type",
        },
        {
          title: "ID",
          value: "id",
          placeholder: "ID (Numbers only)",
        },
      ],
      dataForm: {
        kwType: "clientCode",
        keyword: "",
        companyName: "",
        clientCode: "",
        transactionNo: "",
        inChargeUserName: "",
        status: [],
        fyEndMonth: [],
        companyType: "",
        companyCountry: "",
        uen: "",
        controlType: [],
        controlStatus: [],
        isBlank: 0,
        controlDeadlineStart: "",
        controlDeadlineEnd: "",
        coveredPeriodStart: "",
        coveredPeriodEnd: "",
        incorpDateStart: "",
        incorpDateEnd: "",
        supplierId: "",
        "orders[0].asc": false,
        "orders[0].column": "t1.client_code",
      },
      dataList: [],
      dataListLoading: false,
      inChargeList: [],
      supplierList: [],
      batchDownBtnLoading: false,
    };
  },
  computed: {
    ...mapState("constant", [
      "countryList",
      "engagementCompanyTypeList",
      "engagementStatusList",
      "engagementControlTypeList",
      "engagementControlLinkedServiceTypeList",
      "engagementControlStatusList",
      "monthOptions",
    ]),
    controlTypeObjList() {
      // 将[""]格式改变成[{title: "", value: ""}]
      return this.engagementControlTypeList.map(item => {
        return { title: item, value: item };
      });
    },
  },
  methods: {
    // 获取in charge列表
    getInChargeList() {
      return new Promise((resolve, reject) => {
        this.$http
          .get("/admin/inChargeUserMa/getList")
          .then(res => {
            const resData = res.data || [];
            this.inChargeList = resData;
            resolve();
          })
          .catch(err => {
            reject();
          });
      });
    },
    // 获取供应商列表
    getSupplierList() {
      return new Promise((resolve, reject) => {
        this.$http
          .get("/admin/supplier")
          .then(res => {
            this.supplierList = res.data || [];
            resolve();
          })
          .catch(err => {
            reject();
          });
      });
    },
    // 根据状态返回对应颜色
    statusDeadColor(cellValue) {
      const one = this.engagementControlStatusList.find(i => i.value === cellValue);
      if (one.value == "NOT_STARTED") {
        return "red";
      } else if (one.value == "IN_PROGRESS") {
        return "green";
      }
    },
    // Service Type table格式化
    serviceTypeFormat(row, column, list) {
      if (list && list.length == 0) return [];
      let arrRes = [];
      this.engagementControlLinkedServiceTypeList.forEach(ele => {
        let serviceDetails = [];
        list.forEach(item => {
          if (item.linkedServiceType.includes(ele.value)) {
            serviceDetails.push(item.controlDesp);
          }
        });
        if (serviceDetails.length > 0) {
          arrRes.push(ele.title);
        }
      });
      return arrRes.join(", ");
    },
    // isBlank change
    isBlankChange() {
      if (this.dataForm.isBlank) {
        this.$set(this.dataForm, "controlStatus", []);
        this.$set(this.dataForm, "controlDeadlineStart", "");
        this.$set(this.dataForm, "controlDeadlineEnd", "");
      }
    },
    // table - 排序
    customTableSortChange(column) {
      if (["incorpDate", "coveredPeriodStart", "clientCode"].includes(column.prop)) {
        // 使用tableMixin中的排序方法
        this.tableSortChange(column);
      } else {
        this.dataForm["orders[0].column"] = "id";
        if (column.order === "descending") {
          this.dataForm["orders[0].asc"] = false; //倒序
          this.getDataList();
        } else if (column.order === "ascending") {
          this.dataForm["orders[0].asc"] = true; //正序
          this.getDataList();
        }
      }
    },
    // 获取数据分页
    async getDataList(current) {
      this.dataListLoading = true;
      if (current) {
        this.current = current;
      }
      const params = {
        current: this.current,
        size: this.pageSize,
        ...this.dataForm,
        [this.dataForm.kwType]: this.dataForm.keyword,
      };
      const { code, data } = await this.$http.get("/admin/engagementManage/paging", {
        params,
      });
      if (code === 200) {
        this.dataList = data.records;
        this.totalCount = data.total;
      } else {
        this.dataList = [];
        this.totalCount = 0;
      }
      this.dataListLoading = false;
    },
    // 新增 / 修改
    addOrUpdateHandle(row) {
      this.$refs.addOrUpdate.init(row);
    },
    // 删除
    async deleteHandle(row) {
      console.log(row);
      if (row.fyPeriod || row.fyEnd || row.controlDataList.length > 0 || row.relatedUserTransactions.length > 0 || row.status == "CLOSE") {
        this.$message({
          type: "warning",
          dangerouslyUseHTMLString: true,
          message: `<div>
          <strong>Delete failed.</strong>
          <p class="mt4 lh16">Please check with this transaction details, and delete filled information in transaction details before this action.</p>
          </div>`,
        });
        return;
      }
      await this.$confirm(`Delete this Engagement. Continue?`, "Warning", {
        confirmButtonText: "OK",
        cancelButtonText: "Cancel",
        type: "warning",
      });
      const { code, msg } = await this.$http.post(`/admin/engagementManage/${row.id}/delete`, {});
      if (code === 200) {
        this.$message({
          message: "success",
          type: "success",
          duration: 1500,
          onClose: () => {
            // mixins
            this.singleDataDelete();
            this.getDataList();
          },
        });
      } else {
        this.$message.error(msg);
      }
    },
    // 详情
    detailHandler(id) {
      this.$router.push(`/engagement/${id}`);
    },
    // 导出所有Excel
    async handleExportExcel() {
      await this.$confirm(`Export excel. Continue?`, "Warning", {
        confirmButtonText: "OK",
        cancelButtonText: "Cancel",
        type: "warning",
      });
      const dataFormCopy = JSON.parse(JSON.stringify(this.dataForm));
      const params = {
        ...dataFormCopy,
        [dataFormCopy.kwType]: dataFormCopy.keyword,
      };
      // 删除之前的排序
      delete params["orders[0].asc"];
      delete params["orders[0].column"];

      this.batchDownBtnLoading = true;
      this.$http
        .get("/admin/engagementManage/export", {
          params,
          responseType: "blob",
        })
        .then(res => {
          downloadFile(res);
        })
        .finally(() => {
          this.batchDownBtnLoading = false;
        });
    },
  },
  async activated() {
    try {
      this.dataListLoading = true;
      await this.getSupplierList();
      await this.getInChargeList();
    } finally {
      this.getDataList();
    }
  },
};
</script>
<style lang="scss" scoped>
.red {
  color: #e54d42;
}

.green {
  color: #8dc63f;
}

.el-form--inline {
  .el-form-item {
    vertical-align: middle;
  }
}

.datePicker {
  ::v-deep .el-input__inner {
    border: none;
    padding-left: 0;
    padding-right: 0;
    text-align: center;
    background-color: transparent !important;
    cursor: text;
  }

  ::v-deep .el-input__prefix {
    display: none !important;
    ::v-deep .el-input__icon {
      display: none !important;
      width: 0 !important;
    }
  }

  ::v-deep .el-input__suffix {
    display: none !important;
  }
}

.controlLeft {
  ::v-deep input {
    // border-right: none;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
  ::v-deep .el-input__inner:focus {
    border-color: #dcdfe6 !important;
  }

  ::v-deep .el-input__inner.is-focus {
    border-color: #dcdfe6 !important;
  }

  ::v-deep .el-input:focus {
    .el-input__inner {
      border-color: #dcdfe6 !important;
    }
  }

  ::v-deep .el-input.is-focus {
    .el-input__inner {
      border-color: #dcdfe6 !important;
    }
  }
}

.controlCentre {
  ::v-deep input {
    border-left: none;
    border-radius: 0;
  }
  ::v-deep .el-input__inner:focus {
    border-color: #dcdfe6 !important;
  }

  ::v-deep .el-input__inner.is-focus {
    border-color: #dcdfe6 !important;
  }

  ::v-deep .el-input:focus {
    .el-input__inner {
      border-color: #dcdfe6 !important;
    }
  }

  ::v-deep .el-input.is-focus {
    .el-input__inner {
      border-color: #dcdfe6 !important;
    }
  }
}

.controlRight {
  border-left: none;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;

  ::v-deep input {
    border-left: none;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
}

.closureCheckCustom {
  .el-message-box__header {
    .el-message-box__title {
      font-size: 16px;
      width: 320px;
      line-height: 22px;
    }
  }

  .el-message-box__content {
    .el-message-box__status {
      display: none;
    }
    .el-message-box__message {
      padding-left: 0;
    }
  }
}
</style>

<style lang="scss">
.confirmButtonCopyFrom {
  background-color: #fff !important;
  color: #606266 !important;
  border-color: #dcdfe6 !important;
}

.confirmButtonCopyFrom:hover {
  color: #0072ff !important;
  border-color: #b3d5ff !important;
  background-color: #e6f1ff !important;
}

.cancelButtonCopyFrom {
  color: #ffffff !important;
  background-color: #0072ff !important;
  border-color: #0072ff !important;
}

.cancelButtonCopyFrom:hover,
.cancelButtonCopyFrom:focus {
  background: #338eff !important;
  border-color: #338eff !important;
  color: #ffffff !important;
}
</style>
